import React, { useEffect, useState} from 'react'
import Modal from 'react-modal'
import { renderTextField, renderButton, renderCancelButton} from '@/shared/FormUtils'
import Dropzone from 'react-dropzone'
import classNames from 'classnames'
import { Stack } from '@mui/material'
import Cookies from 'universal-cookie'
const AttachmentModal = ({
  item,
  open,
  onClose,
  onSave,
  attachmentModalId,
  formikProps,
  user,
  id,
  attachment
}) => {
  isEditing = !!attachment
  const label = formikProps?.values?.custom_field_attachment_label
  const [ attachmentFile, setAttachmentFile ] = useState(null)
  const [ fileName, setFileName ] = useState(null)
  const [ submitting, setSubmitting ] = useState(false)
  
  const onDrop = (acceptedFiles) => {
    if(!submitting) {
      setAttachmentFile(acceptedFiles[0])
      setFileName(acceptedFiles[0].name)
    }
  }

  const renderDropzone = () =>{
    if(attachmentFile){
      return (
        <h3> File Name: {fileName} </h3>
      )
    }

    return (
      <Dropzone onDrop={onDrop}>
        {({ getRootProps, getInputProps, isDragActive }) => {
          return (
            <div
              {...getRootProps()}
              className={classNames("dropzone", "person-create-dropzone-header", {
                "dropzone--isActive": isDragActive
              })}
            >
              <input {...getInputProps()} required/>
                {fileName ? (
                    <p className="text-black">Uploaded:
                      <br />
                      <b> File Name:</b>{fileName}
                    </p>
                ) 
                : (
                  <div className="item-form-dropzone-fallback">
                    <h3>Drop a File or Click to Add an Attachment&nbsp;</h3>
                  </div>
                )}
            </div>
          );
        }}
      </Dropzone>
    )
  }

  useEffect(() => {
    setFileName(attachment ? attachment.filename : "")
    formikProps.setFieldValue(`custom_field_attachment_label`, attachment ? attachment.label : "")
    setAttachmentFile(null)
  }, [attachment, open])

  const renderButtons = () => {
    const label = formikProps?.values?.custom_field_attachment_label
    return (
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
        {renderCancelButton("Cancel", onClose)}
        {renderButton("Save", handleSave, {color: "green", disabled: isSubmitDisabled()})}
      </Stack>
    )
  }

  const isSubmitDisabled = () => {
    const label = formikProps?.values?.custom_field_attachment_label
    if(submitting) return true
    if(isEditing) {
      return !label
    }else {
      return !(label && attachmentFile)
    }
  }
  
  const handleSave = () => {
    if(submitting) return
    setSubmitting(true)
    const label = formikProps?.values?.custom_field_attachment_label
    const formData = new FormData()
    formData.append("item_attachment[label]", label)
    formData.append("item_attachment[item_id]", item.id)
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    if(attachmentFile){
      formData.append("item_attachment[attachment]", attachmentFile)
    }
    fetch(isEditing ? `/webapi/attachments/${attachment.id}` : `/webapi/attachments`, {
      method: isEditing ? "PATCH" : "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": token
      }
    }).then(response => {
      return response.json()
    }).then(json => {
      setSubmitting(false)
      onSave()
    })
  }
  
  return (
    <Modal
      className="react-modal add-form-modal add-custom-field-modal"
      overlayClassName="react-modal-overlay"
      isOpen={open}
      onRequestClose={onClose}
      contentLabel="Add An Attachment"
    >
       <div class="text-emerald-900 text-xl font-medium font-['Roboto'] pb-4">{isEditing ? "Edit Attachment" : "Add Attachment"}</div>
       {!isEditing && (
        renderDropzone()
       )}
       {renderTextField("Label", `custom_field_attachment_label`)}
       {renderButtons()}
    </Modal>
  )
}

export default AttachmentModal